module.exports = __webpack_public_path__ + "img/slider-people-2.3e360b52.png";